import type { ProductTemplateV2 } from '@zopauk/react-components/types/components/styles/Theme';

export const productTemplateV2: ProductTemplateV2 = {
  form: {
    containerClassName: 'jl-form-container',
    subheadingClassName: 'font-medium',
    headingClassName: 'font-medium',
    subheadingPostion: 'before',
  },
  titleClassName: 'pt-7 m:pt-9 font-medium',
  subtitleClassName: 'font-normal',
} as const;
